export default {
  setTitle(title) {
    document.title = title;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', '/favicon.ico');
    var click = () => {
      setTimeout(() => {
        iframe.parentNode.removeChild(iframe);
      }, 0);
    }
    iframe.onload = click;
    document.body.appendChild(iframe);
  },
  hasClass(dom, className = '') {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(dom.className)
  },
  removeClass(dom, className = '') {
    dom.className = obj.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), ' ')
  },
  addClass(dom, className = '') {
    if (!this.hasClass(dom, className)) {
      dom.className += ' ' + className
    }
  },
  htmlEncode(html) {
    // html 转义  <p> -》 &lt;p&gt;
    var temp = document.createElement("div");
    (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
    var text = temp.innerHTML;
    temp = null;
    return text;
  },
  htmlDecode(text) {
    // html 反转义  &lt;p&gt;  -》<p>
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var html = temp.innerText || temp.textContent;
    temp = null;
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/utils/domUtils.js